/* Wayne3 — motion, one-tap add, and the mini cart drawer.
   Blueprint spec: reveal 0.9s/22px stagger, hero crossfade 1.6s per 5s,
   quiet quick-add that opens a cart drawer the shopper can edit in place.
   This file is referenced by several w3-* sections AND by w3-announcement
   (so it loads on every page), hence the single-run guard below. */
(function () {
  'use strict';
  if (window.__w3GalerieBooted) return;
  window.__w3GalerieBooted = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var R = window.routes || {};
  var ADD_URL = (R.cart_add_url || '/cart/add') + '.js';
  var CHANGE_URL = (R.cart_change_url || '/cart/change') + '.js';
  var CART_URL = R.cart_url || '/cart';

  /* ------------------------------------------------------------ helpers -- */
  function money(cents, currency) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents); } catch (e) {}
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: currency || 'MYR', currencyDisplay: 'narrowSymbol'
      }).format(cents / 100);
    } catch (e) {
      return (currency || '') + ' ' + (cents / 100).toFixed(2);
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function thumb(url, w) {
    if (!url) return '';
    return url.replace(/(\.(jpg|jpeg|png|webp|gif))(\?|$)/i, '_' + w + 'x$1$3');
  }

  function updateBubbles(count) {
    var bubble = document.querySelector('.cart-count-bubble');
    if (bubble) {
      var span = bubble.querySelector('span[aria-hidden]') || bubble.querySelector('span');
      if (span) span.textContent = count;
      bubble.hidden = count === 0;
      bubble.style.display = count === 0 ? 'none' : '';
      return;
    }
    var icon = document.querySelector('#cart-icon-bubble');
    if (icon && count > 0) {
      var div = document.createElement('div');
      div.className = 'cart-count-bubble';
      div.innerHTML = '<span aria-hidden="true">' + count + '</span>';
      icon.appendChild(div);
    }
  }

  /* --------------------------------------------------------- cart drawer -- */
  var Cart = {
    el: null, itemsEl: null, footEl: null, countEl: null, open: false, busy: false,

    styles: function () {
      if (document.getElementById('w3-cart-style')) return;
      var css = [
        '.w3-cart{position:fixed;inset:0;z-index:1000;visibility:hidden;}',
        '.w3-cart.is-open{visibility:visible;}',
        '.w3-cart__scrim{position:absolute;inset:0;background:rgba(38,24,14,.45);opacity:0;transition:opacity .35s ease;}',
        '.w3-cart.is-open .w3-cart__scrim{opacity:1;}',
        '.w3-cart__panel{position:absolute;top:0;right:0;height:100%;width:min(420px,100%);display:flex;flex-direction:column;',
        'background:var(--w3-cream,#f2f1e6);color:var(--w3-ink,#442d1c);box-shadow:-12px 0 40px -20px rgba(38,24,14,.5);',
        'transform:translateX(100%);transition:transform .4s cubic-bezier(.25,.46,.45,.94);font-family:var(--font-body-family,sans-serif);}',
        '.w3-cart.is-open .w3-cart__panel{transform:none;}',
        '@media (prefers-reduced-motion: reduce){.w3-cart__panel,.w3-cart__scrim{transition:none;}}',
        '.w3-cart__head{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:20px 22px;border-bottom:1px solid rgba(68,45,28,.15);}',
        '.w3-cart__title{margin:0;font-family:var(--font-heading-family,serif);font-size:20px;line-height:1.2;}',
        '.w3-cart__count{font-size:11px;letter-spacing:.16em;text-transform:uppercase;color:var(--w3-muted,#927c5e);margin:4px 0 0;}',
        '.w3-cart__x{background:none;border:0;font-size:24px;line-height:1;cursor:pointer;color:inherit;padding:4px 6px;}',
        '.w3-cart__items{flex:1 1 auto;overflow-y:auto;padding:6px 22px 22px;}',
        '.w3-cart__row{display:grid;grid-template-columns:72px 1fr;gap:14px;padding:18px 0;border-bottom:1px solid rgba(68,45,28,.1);}',
        '.w3-cart__media{width:72px;height:72px;border-radius:6px;overflow:hidden;background:var(--w3-panel,#fef7e6);}',
        '.w3-cart__media img{width:100%;height:100%;object-fit:cover;display:block;}',
        '.w3-cart__name{font-size:14.5px;font-weight:500;line-height:1.35;margin:0 0 2px;color:inherit;text-decoration:none;display:block;}',
        '.w3-cart__name:hover{opacity:.7;}',
        '.w3-cart__variant{font-size:12.5px;color:var(--w3-muted,#927c5e);margin:0 0 8px;}',
        '.w3-cart__line{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-top:8px;}',
        '.w3-cart__qty{display:inline-flex;align-items:center;border:1px solid rgba(68,45,28,.25);border-radius:999px;overflow:hidden;}',
        '.w3-cart__qty button{width:30px;height:30px;border:0;background:none;cursor:pointer;font-size:15px;line-height:1;color:inherit;}',
        '.w3-cart__qty button:hover{background:rgba(68,45,28,.08);}',
        '.w3-cart__qty span{min-width:26px;text-align:center;font-size:13.5px;font-variant-numeric:tabular-nums;}',
        '.w3-cart__price{font-size:13.5px;font-variant-numeric:tabular-nums;}',
        '.w3-cart__remove{background:none;border:0;padding:0;margin-top:6px;font-size:12px;letter-spacing:.04em;color:var(--w3-muted,#927c5e);cursor:pointer;text-decoration:underline;}',
        '.w3-cart__remove:hover{color:var(--w3-ink,#442d1c);}',
        '.w3-cart__empty{padding:48px 0;text-align:center;color:var(--w3-muted,#927c5e);font-size:14px;}',
        '.w3-cart__foot{padding:18px 22px 22px;border-top:1px solid rgba(68,45,28,.15);background:var(--w3-panel,#fef7e6);}',
        '.w3-cart__sub{display:flex;justify-content:space-between;align-items:baseline;font-size:15px;margin-bottom:4px;}',
        '.w3-cart__note{font-size:12px;color:var(--w3-muted,#927c5e);margin:0 0 14px;}',
        '.w3-cart__acts{display:grid;grid-template-columns:1fr 1fr;gap:10px;}',
        '.w3-cart__btn{display:inline-flex;align-items:center;justify-content:center;padding:13px 16px;border-radius:var(--buttons-radius,4px);',
        'font-size:12.5px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;text-decoration:none;cursor:pointer;border:1px solid var(--w3-ink,#442d1c);}',
        '.w3-cart__btn--ghost{background:transparent;color:var(--w3-ink,#442d1c);}',
        '.w3-cart__btn--solid{background:var(--w3-ink,#442d1c);color:var(--w3-panel,#fef7e6);}',
        '.w3-cart__btn--ghost:hover{background:var(--w3-ink,#442d1c);color:var(--w3-panel,#fef7e6);}',
        '.w3-cart__btn--solid:hover{opacity:.88;}',
        '.w3-cart.is-busy .w3-cart__items{opacity:.5;pointer-events:none;}',
        'body.w3-cart-open{overflow:hidden;}'
      ].join('');
      var tag = document.createElement('style');
      tag.id = 'w3-cart-style';
      tag.textContent = css;
      document.head.appendChild(tag);
    },

    build: function () {
      if (this.el) return;
      this.styles();
      var wrap = document.createElement('div');
      wrap.className = 'w3-cart';
      wrap.setAttribute('role', 'dialog');
      wrap.setAttribute('aria-modal', 'true');
      wrap.setAttribute('aria-label', 'Shopping cart');
      wrap.innerHTML =
        '<div class="w3-cart__scrim" data-w3-cart-close></div>' +
        '<aside class="w3-cart__panel">' +
          '<div class="w3-cart__head"><div>' +
            '<h2 class="w3-cart__title">Your cart</h2>' +
            '<p class="w3-cart__count" data-w3-cart-count></p>' +
          '</div><button type="button" class="w3-cart__x" data-w3-cart-close aria-label="Close cart">&times;</button></div>' +
          '<div class="w3-cart__items" data-w3-cart-items></div>' +
          '<div class="w3-cart__foot" data-w3-cart-foot></div>' +
        '</aside>';
      document.body.appendChild(wrap);
      this.el = wrap;
      this.itemsEl = wrap.querySelector('[data-w3-cart-items]');
      this.footEl = wrap.querySelector('[data-w3-cart-foot]');
      this.countEl = wrap.querySelector('[data-w3-cart-count]');

      var self = this;
      wrap.addEventListener('click', function (e) {
        if (e.target.closest('[data-w3-cart-close]')) { self.hide(); return; }
        var minus = e.target.closest('[data-w3-line-minus]');
        var plus = e.target.closest('[data-w3-line-plus]');
        var kill = e.target.closest('[data-w3-line-remove]');
        if (minus) return self.change(minus.dataset.w3LineMinus, Number(minus.dataset.qty) - 1);
        if (plus) return self.change(plus.dataset.w3LinePlus, Number(plus.dataset.qty) + 1);
        if (kill) return self.change(kill.dataset.w3LineRemove, 0);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.open) self.hide();
      });
    },

    render: function (cart) {
      this.build();
      var rows = '';
      (cart.items || []).forEach(function (it, idx) {
        var line = idx + 1;
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        rows +=
          '<div class="w3-cart__row">' +
            '<a class="w3-cart__media" href="' + esc(it.url) + '">' +
              (it.image ? '<img src="' + esc(thumb(it.image, 160)) + '" alt="' + esc(it.product_title) + '" width="72" height="72" loading="lazy">' : '') +
            '</a>' +
            '<div>' +
              '<a class="w3-cart__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
              (variant ? '<p class="w3-cart__variant">' + esc(variant) + '</p>' : '') +
              '<div class="w3-cart__line">' +
                '<span class="w3-cart__qty">' +
                  '<button type="button" data-w3-line-minus="' + line + '" data-qty="' + it.quantity + '" aria-label="Decrease quantity">&minus;</button>' +
                  '<span>' + it.quantity + '</span>' +
                  '<button type="button" data-w3-line-plus="' + line + '" data-qty="' + it.quantity + '" aria-label="Increase quantity">+</button>' +
                '</span>' +
                '<span class="w3-cart__price">' + money(it.line_price, cart.currency) + '</span>' +
              '</div>' +
              '<button type="button" class="w3-cart__remove" data-w3-line-remove="' + line + '">Remove</button>' +
            '</div>' +
          '</div>';
      });

      if (!rows) {
        rows = '<p class="w3-cart__empty">Your cart is empty.<br><a href="/collections/craft-bakery" style="color:inherit">Browse our bakes</a></p>';
        this.footEl.innerHTML = '';
      } else {
        this.footEl.innerHTML =
          '<div class="w3-cart__sub"><span>Subtotal</span><strong>' + money(cart.total_price, cart.currency) + '</strong></div>' +
          '<p class="w3-cart__note">Taxes and delivery calculated at checkout.</p>' +
          '<div class="w3-cart__acts">' +
            '<a class="w3-cart__btn w3-cart__btn--ghost" href="/collections/birthday-decorations">Add-on</a>' +
            '<a class="w3-cart__btn w3-cart__btn--solid" href="' + esc(CART_URL) + '">View cart</a>' +
          '</div>';
      }
      this.itemsEl.innerHTML = rows;
      this.countEl.textContent = cart.item_count === 1 ? '1 item' : cart.item_count + ' items';
      updateBubbles(cart.item_count);
      document.dispatchEvent(new CustomEvent('w3:cart:updated', { detail: { cart: cart } }));
    },

    refresh: function () {
      var self = this;
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); return cart; });
    },

    change: function (line, qty) {
      var self = this;
      if (self.busy) return;
      self.busy = true;
      if (self.el) self.el.classList.add('is-busy');
      return fetch(CHANGE_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(qty)) })
      }).then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); })
        .catch(function () { return self.refresh(); })
        .then(function () {
          self.busy = false;
          if (self.el) self.el.classList.remove('is-busy');
        });
    },

    show: function () {
      this.build();
      this.el.classList.add('is-open');
      document.body.classList.add('w3-cart-open');
      this.open = true;
    },

    hide: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      document.body.classList.remove('w3-cart-open');
      this.open = false;
    },

    openWithCart: function () {
      var self = this;
      self.build();
      self.show();
      if (!self.itemsEl.innerHTML) self.itemsEl.innerHTML = '<p class="w3-cart__empty">Loading…</p>';
      return self.refresh();
    }
  };

  window.W3Cart = Cart;

  function initCartIcon() {
    var icons = document.querySelectorAll('#cart-icon-bubble, a[href$="/cart"].header__icon--cart');
    Array.prototype.forEach.call(icons, function (icon) {
      if (icon.dataset.w3Bound === 'true') return;
      icon.dataset.w3Bound = 'true';
      icon.addEventListener('click', function (e) {
        e.preventDefault();
        Cart.openWithCart();
      });
    });
  }

  /* ------------------------------------------------------------- motion -- */
  function initReveal(root) {
    var nodes = (root || document).querySelectorAll('[data-w3-reveal]:not(.is-in)');
    if (!nodes.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  function initHero(section) {
    var wrap = section.querySelector('[data-w3-hero]');
    if (!wrap || wrap.dataset.booted === 'true') return;
    wrap.dataset.booted = 'true';
    var slides = [].slice.call(wrap.querySelectorAll('.w3-hero__slide'));
    var dots = [].slice.call(wrap.querySelectorAll('.w3-hero__dot'));
    if (slides.length < 2) return;
    var interval = parseInt(wrap.dataset.interval || '5000', 10);
    var i = 0, timer = null;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function play() {
      if (reduce) return;
      if (timer) clearInterval(timer);
      timer = setInterval(function () { show(i + 1); }, interval);
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); play(); }); });
    wrap.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    wrap.addEventListener('mouseleave', play);
    show(0); play();
  }

  /* ---------------------------------------------------------- quick add -- */
  function initAdd(section) {
    section.querySelectorAll('[data-w3-add]').forEach(function (btn) {
      if (btn.dataset.w3Bound === 'true') return;
      btn.dataset.w3Bound = 'true';
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var id = btn.getAttribute('data-w3-add');
        if (!id || btn.dataset.state === 'loading') return;
        btn.dataset.state = 'loading';
        fetch(ADD_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        }).then(function () {
          btn.dataset.state = 'done';
          btn.textContent = '✓';
          Cart.openWithCart();
          setTimeout(function () { btn.dataset.state = ''; btn.textContent = '+'; }, 1600);
        }).catch(function () {
          btn.dataset.state = '';
          btn.textContent = '!';
          setTimeout(function () { btn.textContent = '+'; }, 2000);
        });
      });
    });
  }

  /* --------------------------------------------------------------- boot -- */
  function boot(root) {
    var scope = root || document;
    initReveal(scope);
    initCartIcon();
    scope.querySelectorAll('[data-w3-section]').forEach(function (s) {
      if (s.dataset.w3Booted === 'true') return;
      s.dataset.w3Booted = 'true';
      initHero(s);
      initAdd(s);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
